import React, { createContext, useContext } from 'react';

export const LocationContext = createContext();

export function useLocationState() {
    return useContext(LocationContext);
}
